import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import './AnalyticsTypeSwitcher.css';
import { trackAnalyticsTypeSwitcher } from '../../../Telemetry/Mixpanel/Features/analyticsTracker';
import { LIVE, RECORDING } from '../../../Telemetry/Mixpanel/Constants/mixpanelConstants';

class AnalyticsTypeSwitcher extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  render() {
    const { t } = this.context;
    return (
      <div className="analyticsTypeSwitcher">
        <div onClick={() => trackAnalyticsTypeSwitcher(LIVE)}>
          <NavLink to="/analytics/sessions" activeClassName="selected">
            {t('header.analyticsType.live')}
          </NavLink>
        </div>
        <div onClick={() => trackAnalyticsTypeSwitcher(RECORDING)}>
          <NavLink to="/analytics/recordings" activeClassName="selected">
            {t('header.analyticsType.recording')}
          </NavLink>
        </div>
      </div>
    );
  }
}
export default AnalyticsTypeSwitcher;



// WEBPACK FOOTER //
// ./src/GoToWebinar/Dashboard/Header/AnalyticsTypeSwitcher.js